/**
 * variants/glow/ActionIcons.jsx
 * Common action SVG glyphs for Homy in "spatial-bento-glow" variant.
 */

import * as React from "react";

function createSvgIcon(name, renderPaths) {
  const Component = React.forwardRef(
    ({ size, width, height, className = "", embedded = false, ...props }, ref) => {
      const dimension = size || width || 24;

      if (embedded) {
        return (
          <g
            ref={ref}
            className={`filter drop-shadow-[0_0_4px_currentColor] ${className}`}
            data-icon={name}
            {...props}
          >
            {renderPaths()}
          </g>
        );
      }

      return (
        <svg
          ref={ref}
          viewBox="0 0 24 24"
          width={dimension}
          height={height || dimension}
          fill="none"
          stroke="currentColor"
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
          className={`filter drop-shadow-[0_0_4px_currentColor] ${className}`}
          data-icon={name}
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          {renderPaths()}
        </svg>
      );
    }
  );
  Component.displayName = name;
  return Component;
}

export const PlusIcon = createSvgIcon("PlusIcon", () => (
  <>
    <circle cx="12" cy="12" r="8" fill="currentColor" fillOpacity="0.25" stroke="none" />
    <path d="M12 5v14M5 12h14" />
  </>
));

export const EditIcon = createSvgIcon("EditIcon", () => (
  <>
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" fill="currentColor" fillOpacity="0.25" />
  </>
));

export const TrashIcon = createSvgIcon("TrashIcon", () => (
  <>
    <path d="M3 6h18M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
    <path d="M10 11v6M14 11v6" />
  </>
));

export const SearchIcon = createSvgIcon("SearchIcon", () => (
  <>
    <circle cx="11" cy="11" r="7" fill="currentColor" fillOpacity="0.25" stroke="none" />
    <circle cx="11" cy="11" r="7" />
    <path d="M21 21l-4.35-4.35" />
  </>
));

export const FilterIcon = createSvgIcon("FilterIcon", () => (
  <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" fill="currentColor" fillOpacity="0.25" />
));

export const CloseIcon = createSvgIcon("CloseIcon", () => (
  <>
    <circle cx="12" cy="12" r="8" fill="currentColor" fillOpacity="0.25" stroke="none" />
    <path d="M18 6L6 18M6 6l12 12" />
  </>
));

export const CheckIcon = createSvgIcon("CheckIcon", () => (
  <>
    <circle cx="12" cy="12" r="8" fill="currentColor" fillOpacity="0.25" stroke="none" />
    <path d="M20 6L9 17l-5-5" />
  </>
));

export const ChevronLeftIcon = createSvgIcon("ChevronLeftIcon", () => (
  <path d="M15 18l-6-6 6-6" />
));

export const ChevronRightIcon = createSvgIcon("ChevronRightIcon", () => (
  <path d="M9 18l6-6-6-6" />
));

export const ChevronDownIcon = createSvgIcon("ChevronDownIcon", () => (
  <path d="M6 9l6 6 6-6" />
));

export const ChevronUpIcon = createSvgIcon("ChevronUpIcon", () => (
  <path d="M18 15l-6-6-6 6" />
));

export const glowActionGlyphs = {
  plus: PlusIcon,
  edit: EditIcon,
  trash: TrashIcon,
  search: SearchIcon,
  filter: FilterIcon,
  close: CloseIcon,
  check: CheckIcon,
  "chevron-left": ChevronLeftIcon,
  "chevron-right": ChevronRightIcon,
  "chevron-down": ChevronDownIcon,
  "chevron-up": ChevronUpIcon,
};
